import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { domElements } from '../constants/selectors';
import { IframeErrorPage } from './IframeErrorPage';
import useAppEmbedder from '../utils/useAppEmbedder';
import { Apps } from './constants';
export const IframePortal = (props) => {
    const container = document.getElementById(domElements.leadinIframeContainer);
    const iframeNotRendered = useAppEmbedder(Apps.Forms, container);
    if (container && !iframeNotRendered) {
        return ReactDOM.createPortal(props.children, container);
    }
    return (_jsx(Fragment, { children: (!container || iframeNotRendered) && _jsx(IframeErrorPage, {}) }));
};
export const renderIframeApp = () => {
    const iframeFallbackContainer = document.getElementById(domElements.leadinIframeFallbackContainer);
    ReactDOM.render(_jsx(IframePortal, {}), iframeFallbackContainer);
};
